module.exports = __webpack_public_path__ + "img/linkedin-icon-white.b40c6bc0.svg";